import React, { useState, useEffect, useContext } from 'react';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import Loading from 'tbk-components/src/components/Loading';
import Modal from 'tbk-components/src/components/Modal';
import CareersInnerSidebarForm from '../CareersInnerSidebar/CareersInnerSidebarForm';

export interface IDashboardApplicationModalProps {
	careerID: number;
	onCancel: () => void;
	context?: { Api: any };
}

const DashboardApplicationModal: React.FC<IDashboardApplicationModalProps> = withAppContext(({
	careerID = 0,
	onCancel = () => void 0,
	context
}) => {
	// NOTE: This is a work in progress.  Logically, the app is never supposed to show this.  That's because it would only show
	// for Deskflow jobs where the user has done a Quick Apply.  But the UI doesn't currently allow quick apply on Deskflow jobs.
	// If we ever get to the point of wanting to make that happen, then we'll need to come back here and get this working and tested.
	// What's left is to get the isConfirmed set properly, which can be modelled after what's in CareersInnerSidebar.
	const { Api } = useContext<{ Api: any }>(context);
	const [form, setForm] = useState<{markup:string;title?:string;description?:string;logoTagline?:string;}>(null);
	const [isConfirmed,setIsConfirmed] = useState(false);

	useEffect(() => {
		if (Api.getCareerForm) {
			Api.getCareerForm({form:'full_apply_form',ID:careerID}).then(
				({form, hydrationProps}) => {
					setForm(form);
					// @ts-ignore
					if ( window?.TBK_HYDRATE_COMPONENTS ) {
						// @ts-ignore
						Object.assign( window.TBK_HYDRATE_COMPONENTS, hydrationProps );
					}
				}
			);
		} else {
			setForm({
				markup: '',
				title: 'Oops',
				description: 'Subsite Api does not work in storybook',
				logoTagline: 'Careers',
			});
		}
	}, [careerID]);
	useEffect( () => {
		// @ts-ignore
		if ( ! form || ! window?.tbk_gutenberg_render ) {
			return;
		}
		// @ts-ignore
		window.tbk_gutenberg_render();
	}, [form]);

	return (
		<Modal
			onCancel={onCancel}
			id="dashboard-application-modal"
			// If hasRegistrationCTA is true, then add class to modal
			modalClassNames={[
				'calian-careers-inner-sidebar__modal modal-dialog modal-dialog-centered',
			]}
			headerClassNames={[
				'modal-header',
				'position-absolute',
				'top-0',
				'start-0',
				'w-100',
			]}
			bodyClassNames={['modal-body', 'p-0']}
		>
			{form
				? (<div className="container-fluid g-0">
					<div className="row g-0 calian-careers-inner-sidebar__full-apply-modal">
						<div
							className="col-12 py-8 px-3 px-lg-9"
						>
							{form.title && !isConfirmed && (
								<h2 className="text-center">
									{form.title}
								</h2>
							)}
							{form.description && !isConfirmed && (
								<p className="calian-careers-inner-sidebar__modal--text text-center w-md-70 mx-auto mb-4">
									{form.description}
								</p>
							)}
							<div className="calian-careers-inner-sidebar__modal--form">
								<CareersInnerSidebarForm
									isConfirmation={isConfirmed}
									logoTagline={form.logoTagline}
									children={<div dangerouslySetInnerHTML={{__html:form.markup}}/>}
								/>
							</div>
						</div>
					</div>

				</div>)
			: (
				<Loading />
			)}
		</Modal>
	);
});

export default DashboardApplicationModal;
